<template>
  <div class="payment-selection-container">
    <div class="header-actions">
      <el-button round icon="el-icon-back" @click="$emit('back', 'method')">返回</el-button>
    </div>

    <div class="content-wrapper">
      <div class="total-amount">
        訂單總計 <span class="highlight">NT$ {{ paymentInfo.total || 0 }}</span>
      </div>

      <el-row :gutter="20" type="flex" justify="center" class="m-b-24">
        <el-col v-if="paymentInfo.paymentMethods.includes('Credit')" :xs="24" :sm="10" :md="10">
          <div class="payment-card" @click="handleSelect('Credit')">
            <div class="icon-circle">
              <svg class="strokeFull" height="56.299" viewBox="0 0 56.213 56.299" width="56.213" xmlns="http://www.w3.org/2000/svg">
                <g fill="none" stroke="#e86a35" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" transform="translate(.5 .5)">
                  <path d="m17.026 54.8h-11.804a4.722 4.722 0 0 1 -4.722-4.722v-44.856a4.722 4.722 0 0 1 4.722-4.722h23.608a4.722 4.722 0 0 1 4.722 4.722v21.247" />
                  <path d="m33.713 9.713h-33" />
                  <path d="m17.713 45.713h-17" />
                  <path d="m11.713 5.713h10" />
                  <path d="m21.713 37.713h33" />
                  <path d="m35.713 43.713h-9" />
                  <path d="m49.713 43.713h-4" />
                  <path d="m31.713 46.713h-5" />
                  <rect height="23" rx="2" width="33" x="21.713" y="31.713" />
                  <path d="m6.109 18.279a3.284 3.284 0 1 0 3.284-3.284 3.284 3.284 0 1 1 3.284-3.284" transform="translate(7.633 10.787)" />
                  <path d="m17.026 32.352v2.186" />
                  <path d="m17.026 17.026v2.191" />
                </g>
              </svg>
            </div>
            <h3 class="card-title">線上信用卡</h3>
          </div>
        </el-col>
        <el-col v-if="paymentInfo.paymentMethods.includes('Vacc')" :xs="24" :sm="10" :md="10">
          <div class="payment-card" @click="handleSelect('Vacc')">
            <div class="icon-circle">
              <svg height="59.819" viewBox="0 0 59.819 59.819" width="59.819" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="m27.939 0v2.941a4.411 4.411 0 0 0 0 8.823h2.941a1.47 1.47 0 1 1 0 2.941h-7.352v2.941h4.411v2.941h2.941v-2.941a4.411 4.411 0 1 0 0-8.823h-2.941a1.47 1.47 0 0 1 0-2.941h7.352v-2.941h-4.411v-2.941zm-7.352 11.54-20.587 6.496v8.432h2.941v23.532h-2.941v8.823h58.819v-8.823h-2.941v-23.531h2.941v-8.433l-20.587-6.5v3.079l17.646 5.585v3.332h-52.937v-3.342l17.646-5.572zm-14.705 14.929h2.941v23.531h-2.941zm5.882 0h5.882v23.531h-5.882zm8.823 0h2.941v23.531h-2.941zm5.882 0h5.882v23.531h-5.882zm8.823 0h2.941v23.531h-2.941zm5.882 0h5.882v23.531h-5.882zm8.823 0h2.941v23.531h-2.938zm-47.056 26.468h52.937v2.941h-52.937z"
                  fill="#ea6a2a"
                  stroke="#fff"
                  transform="translate(.5 .5)"
                />
              </svg>
            </div>
            <h3 class="card-title">虛擬帳戶</h3>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Step3OnlineType',
  props: {
    paymentInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    handleSelect(val) {
      this.$emit('next', { key: 'type', value: val })
    },
  },
}
</script>

<style lang="scss" scoped>
.payment-selection-container {
  padding: 20px;
  background-color: #fcfcfc;
  min-height: 80vh;

  .total-amount {
    text-align: center;
    font-size: 1.1rem;
    color: #666;
    margin-bottom: 40px;
    .highlight {
      color: #ea6a2a;
      font-weight: bold;
      margin-left: 10px;
    }
  }

  .m-b-24 {
    margin-bottom: 24px;
  }

  .payment-card {
    background: #fff;
    border: 1px solid #eee;
    border-radius: 8px;
    padding: 45px 20px;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    flex-direction: column;
    align-items: center;

    &:hover:not(.disabled) {
      border-color: #ea6a2a;
      transform: translateY(-2px);
      box-shadow: 0 8px 20px rgba(0, 0, 0, 0.05);
    }

    &.disabled {
      cursor: not-allowed;
      opacity: 0.7;
      background-color: #fafafa;
    }

    .icon-circle {
      width: 100px;
      height: 100px;
      border: 1.5px solid #ea6a2a;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 44px;
      color: #ea6a2a;
      margin-bottom: 20px;
      overflow: hidden;
    }

    .card-title {
      font-size: 1.1rem;
      color: #444;
      margin: 0;
      font-weight: 500;
    }
  }
}
</style>
